import { Fingerprint } from "lucide-react";

import type { FilterDefinition } from "./FilterDefinition";

/**
 * Comparator and icon preset for resource-id flavored string fields: opaque
 * identifiers the backend matches exactly, so `CONTAINS` / `LIKE` carry no
 * useful meaning. The comparators are the ones `RESOURCE_ID_FIELD_COMPARATORS`
 * in `packages/roboql/src/roboql/model/core.py` puts on every resource-id
 * field, which the backend enforces before any predicate is generated;
 * `resourceIdFilter.test.ts` fails if this list and the generated RoboQL
 * catalog disagree for any field the preset is applied to. The fingerprint
 * glyph replaces the type-default string icon on these rows.
 *
 * Spread it into a `string` filter definition so a rename of either key is a
 * compile error rather than a silently dropped restriction:
 *
 *     { type: "string", field: "collection_id", name: "Collection Id", ...resourceIdFilter }
 */
export const resourceIdFilter = {
  allowedComparators: ["EQUALS", "NOT_EQUALS"],
  icon: <Fingerprint />,
} as const satisfies Partial<FilterDefinition>;
